import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import GeneratorPage from './pages/GeneratorPage';
import TemplatesPage from './pages/TemplatesPage';
import SavedPage from './pages/SavedPage';
import { ToastProvider } from './components/common/Toast';
import { QRProvider } from './hooks/useQRContext';
import { ThemeProvider } from './hooks/useTheme';

/**
 * Main App component
 * Sets up routing and global providers
 */
function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <QRProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="generator" element={<GeneratorPage />} />
              <Route path="templates" element={<TemplatesPage />} />
              <Route path="saved" element={<SavedPage />} />
            </Route>
          </Routes>
        </QRProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
